import Nav from '../../webroot/media/scripts/shared/nav'
import Login from '../../webroot/media/scripts/shared/login'
import LoginForm from '../../webroot/media/scripts/shared/loginForm'
import Widgets from './el/widgets'
import VideoLink from './el/VideoLink'
import {
  initWelcomePopup,
  validatePhoneInput,
} from '../../webroot/media/scripts/shared'
import FavoritesModal from '../../webroot/media/scripts/shared/favoritesModal'
import handleAnchorDownload, { MakeDisableLinkEl } from '../utils/handleAnchorDownload'
import isIframe from '../utils/isIframe'
import forceUpdateUrl from '../utils/forceUpdateUrl'
import prepareLongFileName from '../utils/prepareLongFileName'
import { LOCAL_STORAGE_KEYS } from '../Constants/global'
import { showErrorProductPage } from './shared'
import '../utils/domPolyfills'


document.addEventListener(
  'DOMContentLoaded',
  () => {
    const portalDomain = window.portalDomain
    const lib = (window.lib = {})

    window.onload = () => {
      document.body.classList.add('loaded')
    }

    const videos = document.querySelectorAll('.video-initializing');

    [].forEach.call(videos, (el, i) => {
      VideoLink.init(el)
    })

    Nav.run()
    if (!window.isAuthorized) {
      // if we have new login form on the page
      if (document.getElementById('login-form')) {
        LoginForm.run()
      } else {
        Login.run()
      }
    }

    if (navigator.userAgent.includes('MSIE 8')) {
      $(document.body).addClass('ie8')
      lib.ie8 = true
    }

    if (navigator.userAgent.includes('Awesomium')) {
      lib.awesomium = true
    }

    Widgets.run({ lib })

    function escapeHtml (unsafe) {
      return unsafe
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
    }

    window.onerror = (errorMsg, url, lineNumber, column, errorObj) => {
      if (errorMsg.includes('Script error.')) {
        return
      }

      const data = {
        href: location.href,
        errorMsg: escapeHtml(errorMsg),
        scriptUrl: escapeHtml(url),
        lineNumber,
        column,
        // stackTrace <-- http://stackoverflow.com/questions/6715571/how-to-get-result-of-console-trace-as-string-in-javascript-with-chrome-or-fire
        stackTrace: errorObj ? escapeHtml(errorObj.stack) : errorObj,
        userAgent: escapeHtml(window.navigator.userAgent),
      }

      const jsonString = JSON.stringify(data)
      const escapedJsonString = escapeHtml(jsonString)

      $('body').append(
        $('<div>', {
          class: 'js-dump',
          style: 'display: none;',
          text: escapedJsonString,
        }),
      )
    }

    // for lectora and captivate..  sort of debug..
    let jsDBGCounter = 0

    $('#header').on('click', () => {
      if (jsDBGCounter >= 0 && jsDBGCounter < 6) {
        // many clicks on header)
        if (jsDBGCounter === 0) {
          setTimeout(() => {
            jsDBGCounter = 0
          }, 1000)
        }

        jsDBGCounter++

        return
      }

      $('.js-dump').show()
      if (!$('.js-debugger').length) {
        $('body').append(
          '<textarea class="js-debugger" style="position: fixed; top: 10px; left: 10px;z-index:1000;"></textarea>',
        )
        $('.js-debugger').on('change', function () {
          /* eslint no-eval: 0 */
          eval(this.value)
        })
      }
    })

    const $cutoutAdvancedSearch = $('.js-search-body')

    if ($cutoutAdvancedSearch.length) {
      const $advancedSearchCheckboxes = $cutoutAdvancedSearch.find(
        '[type=checkbox]',
      )

      $('.js-advanced-link').on('click', function (e) {
        e.preventDefault()

        $cutoutAdvancedSearch.slideToggle()
        $(this).toggleClass('active')
      })

      $advancedSearchCheckboxes.on('click', function () {
        const $select = $(this).closest('.search-drop')

        if ($select.find('[type=checkbox]:checked').length) {
          $select.addClass('active')
        } else {
          $select.removeClass('active')
        }
      })
    }

    FavoritesModal.run()

    $(document).on('click', '.js-download-link', function (event) {
      const $t = $(this)
      const $item = $t.closest('.item')

      if ($item && !$item.find('.product-dot--green').length) {
        $item.find('.product-status').append('<span class="product-dot product-dot--green"></span>')
        $item
          .find('.product-popup__status')
          .append(
            `<a href= '${portalDomain}/downloads' class='product-popup__status-download'>
              <span class='product-dot product-dot--green'></span> Previously Downloaded
            </a>`,
          )
      }

      event.stopPropagation()
      event.preventDefault()

      const anchorElement = event.target
      const productUrl = anchorElement.getAttribute('href')
      const productName = anchorElement.getAttribute('data-filename')
      const productType = anchorElement.getAttribute('data-mimetype')

      const verifyProductUrl = productUrl.replace('download', 'verifyProduct')

      const DownloadLink = new MakeDisableLinkEl(anchorElement)

      DownloadLink.disable()

      window.spiral.ajax({
        url: verifyProductUrl,
        method: 'GET',
        processAnswer: ({ isSuccess, response: { error = null } }) => {
          if (isSuccess) {
            return downloadProduct()
          } else {
            DownloadLink.enable()

            const isMOPPage = document.body.classList.contains('product')
            const errorMessage = error || 'Product is not available.'

            if (isMOPPage) {
              showErrorProductPage(errorMessage)
            } else {
              const productPageLink = productUrl.replace('/download/', '/')

              redirectToMOPWithError(productPageLink, errorMessage)
            }
          }
        },
      })

      function downloadProduct () {
        const isPostMessage = isIframe() && window._isLectoraFrame_

        if (isPostMessage) {
          return loSendDownload()
        }

        return handleAnchorDownload({
          name: productName,
          type: productType,
          href: productUrl,
          disabled: false,
        })
          .then(() => {
            updateDownloadCounter()
            DownloadLink.enable()
          })
          .catch((err) => {
            console.error(`err: ${JSON.stringify(err)}`)
          })
      }

      function loSendDownload () {
        const postedData = JSON.stringify({
          command: 'elbdata',
          name: prepareLongFileName(productName),
          type: productType,
          url: productUrl,
        })

        parent.postMessage(postedData, '*')

        // NOTE: used for load review in product page
        if (window.onPostMessageCallback) {
          window.onPostMessageCallback()
        }

        console.info(`postMessage data: ${postedData}`)

        updateDownloadCounter()
        DownloadLink.enable()
      }

      function updateDownloadCounter () {
        if (window._isDownloadCountable_) {
          const $counter = $('.js-downloads-counter')
          const counterNumber = Number($counter.text())

          $counter.text(counterNumber + 1)
        }
      }

      function redirectToMOPWithError (productPageLink, message) {
        // TODO: move to localstorage config
        window.localStorage.setItem(LOCAL_STORAGE_KEYS.MOP_ERROR, String(message))

        window.location = productPageLink
      }
    })

    $(document).on('submit', 'form', () => {
      localStorage.setItem('seriesScrollTo', null)
      localStorage.setItem('scrollTo', null)
    })

    initWelcomePopup()

    $('.js-phone-input').on('keypress', event => validatePhoneInput(event))

    if (document.querySelector('.membership-page')) {
      $('.js-select').chosen({ disable_search: true })
    }

    if (window.isCaptivatePortal) {
      var backBtn = document.querySelector('.js-back-btn')

      if (location.pathname !== '/') { backBtn.classList.remove('hide') }

      backBtn.addEventListener('click', function (e) {
        e.preventDefault()
        if (window.history) {
          window.history.back()
        }
      })
    }

    // NOTE: Keep the order
    if (isIframe()) {
      window.document.body.querySelectorAll('a[href]').forEach((link) => {
        if (link.href) {
          link.href = forceUpdateUrl(link.href)
        }
      })
    }
  },
)
